import styled from "styled-components"

export const ErrorMessage = styled.div`
  margin-top: 1rem;
  color: red;
`
